import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import cambridge from '../../../images/icons/cambridge.png';
import raffles from '../../../images/icons/raffles.png';
import academyofsingapore from '../../../images/icons/academyofsingapore.png';
import teacherscount from '../../../images/icons/teacherscount.png';
import worldisflat from '../../../images/icons/worldisflat.png';


// ES6 class-style
class EndorsedStatic extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="endorsedStatic">
		<div className="container">
			
			<div className="row">
                <div className="books">     
                    <div className="col-4 collaboration">
                    <p style={{"text-align":"center","margin-left": "0px"}}>Academic collaborations</p>                           
                         {/* <span className="img-wrapper">        
                            <img src={raffles} alt=" Raffles Institution, Singapore" />    
                        </span> */}
                         
                        <span className="img-wrapper">
                            <img src={cambridge} alt="University of Cambridge logo" />
                        </span>
                        
                    </div>
                    <div className="col-4 endorsed">                   
                        <p>Endorsed by</p> 	  
                        <span className="img-wrapper">
                            <a data-ga="Teacher - Endorsed by"><img src={teacherscount} alt="5000 teachers globally" /></a>
                        </span> 
                        
                    </div>     
                    <div className="col-4 recognised"> 
                        <p>Recognised by</p> 	                            
                        <span className="img-wrapper">
                            <a data-ga="Teacher - Featured In - Academy of singapore" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Partner_AoT_Award.pdf"} target="_blank"><img src={academyofsingapore} alt="Academy of Singapore" /></a>
                        </span>   
                        <span className="img-wrapper">
                            <a data-ga="Teacher - Featured In - World is Flat" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf"} target="_blank"><img src={worldisflat} alt="The World Is Flat" /></a>
                        </span>
                    </div>
				</div>
			</div>
		</div>
	</div>
  	);
  }
}

export default EndorsedStatic;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/EndorsedStatic.js